import React from "react";
import { useFormikContext } from "formik";
import { isErrorFormStatus } from "./FormStatus";
import Notification from "../Notification";

function FormStatusError() {
  const { status } = useFormikContext();
  if (!isErrorFormStatus(status)) {
    return null;
  }
  return (
    <Notification type="error" title="Error!">
      {status.error.message}
    </Notification>
  );
}

export default FormStatusError;
